import React, { useEffect } from 'react';
import { Route, Switch, useHistory, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { routes } from '@/router/routes';
import { connect } from 'react-redux';
import { Layout } from 'antd';

const { Content } = Layout;

const MainContent = ({ location, userInfo }) => {

	const history = useHistory();

	useEffect(() => {
		if (['/warranty-card', '/product', '/'].includes(history.location.pathname)) {
			if (userInfo?.roles?.includes('ROLE_ADMIN') || userInfo?.roles?.includes('ROLE_SALES')) {
				history.push('/product');
			} else {
				history.push('/warranty-card');
			}
		}
	}, [userInfo.roles]);

	const handleFilter = permission => {
		return !permission || permission.some(el => userInfo?.roles?.includes(el));
	};

	return (
		<TransitionGroup>
			<CSSTransition classNames="fade" key={location.pathname} timeout={500}>
				<Content style={{ padding: '15px', height: '88vh', overflow: 'auto' }}>
					<div className="shadow-radius">
						<Switch location={location}>
							{routes.map(ele => handleFilter(ele.permission) &&
								<Route render={() => <ele.component />} exact key={ele.path} path={ele.path} />)}
							{/*<Redirect from="/" to={getDefaultRoute()} exact />*/}
							{/*<Redirect to="/error/404" />*/}
						</Switch>
					</div>
				</Content>
			</CSSTransition>
		</TransitionGroup>
	);
};

const mapStateToProps = state => ({ userInfo: state.userInfo });
export default withRouter(connect(mapStateToProps)(MainContent));
